import React from 'react';
import AuditLauncherMenu from '@/audit/components/AuditLauncherMenu';
import HomeLauncherMenu from '@/home/components/HomeLauncherMenu';
import ActivityLauncherMenu from '@/activities/components/ActivityLauncherMenu';
import SearchLauncherMenu from '@/search/containers/SearchLauncherMenu';
import DataLauncherMenu from '@/datasets/containers/DataLauncherMenu';
import CohortLauncherMenu from '@/cohorts/containers/CohortLauncherMenu';
import AccessLauncherMenu from '@/requests/components/AccessLauncherMenu';
import Selectors from '../hooks/selectors';
import AdminLauncherMenu from './AdminLauncherMenu';

const FairLaunchers = () => {
  const state = Selectors.useFairLaunchers();
  return (
    <>
      <HomeLauncherMenu />
      {state.approved && (
        <>
          {state.accessActivities && (<ActivityLauncherMenu />)}
          {state.accessSearch && (<SearchLauncherMenu />)}
          {state.accessDatasets && (<DataLauncherMenu />)}
          {state.accessCohorts && (<CohortLauncherMenu />)}
          {state.accessRequests && (<AccessLauncherMenu />)}
          {state.accessAudit && (<AuditLauncherMenu />)}
          {state.accessAdmin && (<AdminLauncherMenu />)}
        </>
      )}
    </>
  );
};

export default FairLaunchers;
